import { render, staticRenderFns } from "./deb-num.vue?vue&type=template&id=539e5286&scoped=true"
import script from "./deb-num.vue?vue&type=script&lang=js"
export * from "./deb-num.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "539e5286",
  null
  
)

export default component.exports